import React, { useState, useEffect } from "react";
import { Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import useAdminAuth from "../hooks/UseAdminAuth";
import "../styles/dashboard.css";
import { fetchAllowedEmailsAndUsers, fetchResults } from "../utils/fetchData";
import TableAdmin from "../component/TableAdmin";

const Dashboard = () => {
  const { admin } = useAdminAuth();
  const [greeting, setGreeting] = useState("");
  const [combinedData, setCombinedData] = useState([]);
  const [resultData, setResultData] = useState([]);
  const [loadingManageUser, setLoadingManageUser] = useState(true);
  const [loadingResult, setLoadingResult] = useState(true);


  useEffect(() => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) {
      setGreeting("Selamat Pagi");
    } else if (currentHour < 15) {
      setGreeting("Selamat Siang");
    } else if (currentHour < 18) {
      setGreeting("Selamat Sore");
    } else {
      setGreeting("Selamat Malam");
    }
  }, []);

  useEffect(() => {
    const handleManageUserDataChange = fetchAllowedEmailsAndUsers((data) => {
      setCombinedData(data);
      setLoadingManageUser(false);
    });
    const manageUserSubscribe = handleManageUserDataChange();

    const handleResultDataChange = fetchResults((data) => {
      setResultData(data);
      setLoadingResult(false);
    });
    const resultSubscribe = handleResultDataChange();

    return () => {
      if (manageUserSubscribe) manageUserSubscribe();
      if (resultSubscribe) resultSubscribe();
    };
  }, []);

  const manageUserColumns = [
    { key: "id", label: "No." },
    { key: "email", label: "Email" },
    { key: "createdAt", label: "Created On" },
    { key: "statusTes", label: "Status Tes" },
    { key: "statusLogin", label: "Status Login" },
    { key: "updatedAt", label: "Last Logged in" },
  ];

  const resultColumns = [
    { key: "id", label: "No." },
    { key: "email", label: "Email" },
    { key: "name", label: "Name" },
    { key: "personalityType", label: "Personality" },
    { key: "completionDate", label: "Completion Date" },
  ];

  return (
    <>
      <Col
        md={12}
        className="d-flex flex-column justify-content-center align-items-start mt-3 px-3"
      >
        <div>
          <h2>
            {greeting}, {admin.name}!
          </h2>
        </div>
        <div>
          <p className="welcome-text-admin">
            Selamat datang kembali! Waktunya untuk meneliti hasil psikotes dan
            mengelola data peserta dengan semangat baru.
          </p>
        </div>
      </Col>

      <Col md={12} className="my-4">
        <div className="d-flex justify-content-start align-items-center px-2">
          <NavLink to="/adminJaya/manageUser" className="link-title">
            <h4>Manage User <i className="bi bi-box-arrow-in-up-right"></i></h4>
          </NavLink>
        </div>

        <TableAdmin
          columns={manageUserColumns}
          data={combinedData}
          loading={loadingManageUser}
          hideActions={true}
        />
      </Col>

      <Col md={12} className="my-4">
        <div className="d-flex justify-content-start align-items-end px-2">
          <NavLink to="/adminJaya/resultPsikotesUser" className="link-title">
            <h4>List Result Psikotes <i className="bi bi-box-arrow-in-up-right"></i></h4>
          </NavLink>
        </div>

        <TableAdmin
          columns={resultColumns}
          data={resultData}
          loading={loadingResult}
          hideActions={true} 
        />
      </Col>
    </>
  );
};

export default Dashboard;
